import { render } from "./OrderSuccess.vue?vue&type=template&id=64f4dde3"
import script from "./OrderSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__